import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { sentenceInput } from './input.sentence.js';

const sequenceSentenceTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("Sequence"),
  answerType: z.literal("Sentence"),
  items: z.array(sentenceInput.schema)
}).transform(({
  items,
  ...rest
}) => ({
  ...rest,
  content: items.map((it, index) => sentenceInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index,
    arr: items
  }))
}));

export { sequenceSentenceTaskSchema };
//# sourceMappingURL=_schema.js.map
